import Link from 'next/link';

import styles from './styles.module.scss';
import { Props } from './types';

const LoginDropdown = ({ onClick, onMouseOut, classNames }: Props) => {
  return (
    <div className={classNames} onMouseOut={onMouseOut}>
      <div className={styles.dropdown}>
        <div className={styles.item}>
          <Link href="#" onClick={() => onClick('login')}>
            Zaloguj się jako klient
          </Link>
        </div>
        <div className={styles.item}>
          <Link href={`${process.env.NEXT_PUBLIC_LOGIN_VENDOR_URL}`}>
            Zaloguj się jako sprzedawca
          </Link>
        </div>
        <div className={styles.item}>
          <Link href="#" onClick={() => onClick('register')}>
            Zarejestruj się jako klient
          </Link>
        </div>
        <div className={styles.item}>
          <Link href={`${process.env.NEXT_PUBLIC_REGISTER_VENDOR_URL}`}>
            Zarejestruj się jako sprzedawca
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginDropdown;
